import type { ButtonProps } from '@elfsight/widget-ui';
import { Button } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { submitButtonSettings } from './submitButtonSettings';

export function SubmitButton({
  text,
  mode,
  borderColor,
  color = 'rgb(17, 17, 17)',
  fontColor = 'rgb(255, 255, 255)',
  ...forwardingProps
}: ButtonProps) {
  const finalColor = color || submitButtonSettings.submitButtonProps.color;
  const invertedColor = getInvertedColor(finalColor);

  return (
    <Button
      {...forwardingProps}
      text={text}
      color={color}
      borderColor={borderColor}
      mode={mode}
      aria-label={text ?? 'Submit'}
      fontColor={invertedColor}
    />
  );
}
